var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterGloboVirtual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95704 6.02445H15.9845M1.95704 11.0343H15.9845M1.45605 8.52935C1.45605 9.5162 1.65043 10.4934 2.02808 11.4051C2.40573 12.3168 2.95926 13.1452 3.65706 13.8431C4.35487 14.5409 5.18328 15.0944 6.09501 15.472C7.00673 15.8497 7.98392 16.0441 8.97076 16.0441C9.95761 16.0441 10.9348 15.8497 11.8465 15.472C12.7582 15.0944 13.5867 14.5409 14.2845 13.8431C14.9823 13.1452 15.5358 12.3168 15.9134 11.4051C16.2911 10.4934 16.4855 9.5162 16.4855 8.52935C16.4855 6.53633 15.6937 4.62494 14.2845 3.21566C12.8752 1.80637 10.9638 1.01465 8.97076 1.01465C6.97774 1.01465 5.06634 1.80637 3.65706 3.21566C2.24778 4.62494 1.45605 6.53633 1.45605 8.52935Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55325 1.01465C7.14662 3.26874 6.40088 5.87238 6.40088 8.52935C6.40088 11.1863 7.14662 13.79 8.55325 16.0441M9.38822 1.01465C10.7949 3.26874 11.5406 5.87238 11.5406 8.52935C11.5406 11.1863 10.7949 13.79 9.38822 16.0441",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterGloboVirtual);
export default __webpack_public_path__ + "static/media/footer-globo-virtual.e4e6ac1a6e75745935bdaed3620b4d0b.svg";
export { ForwardRef as ReactComponent };